interface PickListViewerProps {
  value: string;
}

export function PickListViewer({ value }: PickListViewerProps) {
  return <span className='text-neutral-950 text-sm flex items-center gap-2'>{value}</span>;
}
